<template>
    <crud-base
      :url="url"
      :columns="columns"
      :onDelete="() => {}"
      :onUpdate="() => {}"
      :onStore="() => {}"
      :enableSearch="true"
      :checkAlerts="true"
      primaryKey="id"
    />
</template>

<script>
import CrudBase from "../../../components/crud/CrudBase";
export default {
  name: "Transportadoras",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/transportadora",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "RAZÃO", field: "razaosocial", sortable: false },
        { label: "CNPJ", field: "cnpj", sortable: false },
        { label: "ATIVO", field: "ativo", sortable: false }
      ],
    };
  },
};
</script>
